"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KycDocumentStatus = void 0;
exports.KycDocumentStatus = {
    CREATED: "CREATED",
    VALIDATION_ASKED: "VALIDATION_ASKED",
    VALIDATED: "VALIDATED",
    REFUSED: "REFUSED",
    OUT_OF_DATE: "OUT_OF_DATE",
};
//# sourceMappingURL=KycDocumentStatus.js.map